import { StyledFooter } from "../styled";
import BottomNavigation from "../bottomNavigation";
import { useLocation } from "react-router-dom";
import { useEffect,useState } from "react";

const Footer = () => {
    const location = useLocation();
    const [zIndex, setZIndex] = useState(2);
    useEffect(() => {
        console.log(location.pathname);
        if(location.pathname === "/openPack") {
            setZIndex(0);
        }else {
            setZIndex(2);
        }
    }, [location?.pathname]);

    return (
        <StyledFooter zIndex={zIndex}>
            <BottomNavigation />
        </StyledFooter>
    );
}

export default Footer;